import React from "react";
import i18n from "../../../../constants/i18n";
import {
  DEVELOPER_BLOCKED_REQUESTS_DETAILS_HEADERS,
  DEVELOPER_BLOCKED_REQUESTS_HISTORY_HEADERS
} from "../../../../constants/table-custom-headers/Developers";
import getBlockedRequestStore from "../../../../stores/developer-store/blocked-requests";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const BlockedRequestsData = withLiteObserverAndTheme(() => {
  const blockRequestsData = getBlockedRequestStore().blockRequestsData.get();
  const blockRequestsDetails =
    getBlockedRequestStore().blockRequestsDetails.get();
  return (
    <React.Fragment>
      <Et3Table
        columns={DEVELOPER_BLOCKED_REQUESTS_HISTORY_HEADERS}
        rows={blockRequestsData}
        title={i18n.get("BLOCKED_REQUESTS_HISTORY")}
        shouldBeFlagged={false}
        titleKey={"BLOCKED_REQUESTS_HISTORY"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DEVELOPER_BLOCKED_REQUESTS_DETAILS_HEADERS}
        rows={blockRequestsDetails}
        title={i18n.get("BLOCKED_REQUESTS_DETAILS")}
        shouldBeFlagged={false}
        titleKey={"BLOCKED_REQUESTS_DETAILS"}
      />
    </React.Fragment>
  );
});

export default BlockedRequestsData;
